<template>
  <div class="h-bg">
    <div class="h-content">
      <div class="h-img"></div>
      <div class="h-main">
        <div class="h-title">
          <img :src="pic" alt="" class="h-logo" /> <span>综合推广平台</span>
        </div>
        <div class="h-form">
          <a-form-model :model="form" :rules="rules">
            <a-form-model-item prop="username">
              <a-input
                class="vd-input-s"
                v-model="form.username"
                placeholder="工号"
              >
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25);"
                />
              </a-input>
            </a-form-model-item>
            <a-form-model-item prop="password">
              <a-input-password
                class="vd-input-s"
                v-model="form.password"
                placeholder="密码"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25);"
                />
              </a-input-password>
            </a-form-model-item>
            <!--            <a-checkbox @change="rememberPassword">-->
            <!--              记住密码-->
            <!--            </a-checkbox>-->
            <a-form-model-item>
              <a-button type="primary" block class="h-button" @click="login">
                登 陆</a-button
              >
            </a-form-model-item>
          </a-form-model>
        </div>

        <div class="h-bottom">
          <span>{{ APP_UPDATE }} | {{ APP_VERSION }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LoginApi } from '@/api'
import md5 from 'js-md5'
import store from '@/store'
import pic from '@/assets/logo_c.png'

export default {
  name: 'Login',
  data() {
    return {
      pic,
      rules: {
        username: [
          {
            required: true,
            message: '请输入工号',
            trigger: ['blur', 'change'],
          },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 18, message: '长度6-18', trigger: 'blur' },
        ],
      },
      form: {
        username: '',
        password: '',
      },
    }
  },
  created() {
    document.addEventListener('keyup', (event) => {
      if (event.which === 13) {
        this.login()
      }
    })
  },
  methods: {
    login() {
      if (this.form.password === '') {
        this.$message.warning('请输入密码')
        return false
      }
      LoginApi({
        username: this.form.username,
        password: md5(this.form.password),
      })
        .then((res) => {
          if (res.code === 1) {
            // 浏览器缓存
            localStorage.setItem('ACCESS_TOKEN', res.token)
            localStorage.setItem('USER_INFO', JSON.stringify(res.info))
            // 保存到 vuex 中
            store.commit('SET_USER_INFO', res.info)
            // 判断用户信息是否完整
            localStorage.setItem('IS_COMPLETE', res.is_complete)
            // 页面需要刷新载入用户信息
            if (res.is_complete) {
              this.$router.go(0)
            } else {
              this.$router.push({ path: '/' })
            }
          } else {
            this.$message.warning(res.msg)
          }
        })
        .catch(() => {})
    },
    rememberPassword(e) {
      console.log(e.target.checked)
    },
  },
}
</script>

<style scoped>
.h-bg {
  /*background-color: #999999;*/
  /*background-image: linear-gradient(to right bottom, pink, yellowgreen);*/
  background-image: url('../assets/bgC.png');
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  width: 100%;
}

.h-content {
  display: flex;
  width: 800px;
  height: 400px;
  position: relative;
  top: 20%;
  margin: auto;
  border-radius: 15px;
  background-color: #ffffff;
  box-shadow: 10px 10px 2px rgba(3, 156, 223, 0.2);
}

.h-img {
  background-image: url('../assets/login_face_2.png');
  background-size: 400px 400px;
  width: 400px;
  height: 400px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}

.h-main {
  width: 400px;
  height: 400px;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}

.h-title {
  color: #00a0e9;
  font-weight: bolder;
  font-family: Microsoft JhengHei, serif;
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: baseline;
  padding-top: 40px;
}

.h-form {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.h-button {
  height: 30px;
  border-radius: 15px;
  font-size: 14px;
}

.h-logo {
  width: 59px;
  height: 28px;
}

.h-bottom {
  color: #999999;
  text-align: center;
}
</style>
